import { Platform } from "react-native";

const TOKEN_KEY = "better-auth-session-token";

// Platform.OS, not `typeof window`: React Native aliases `global.window =
// global` at startup (see setUpGlobals.js), so a `window` check is true on
// iOS/Android too. That previously routed native storage through
// `localStorage`, which doesn't exist there — the write/read silently
// no-op'd inside the try/catch, so sessions never survived an app relaunch.
const isWeb = Platform.OS === "web";

let _secureStore: typeof import("expo-secure-store") | null = null;
let _secureStoreFailed = false;

function getSecureStore() {
  if (_secureStoreFailed) return null;
  if (_secureStore) return _secureStore;
  try {
    _secureStore = require("expo-secure-store");
    return _secureStore;
  } catch {
    _secureStoreFailed = true;
    return null;
  }
}

export function getStoredToken(): string | null {
  if (isWeb) {
    try {
      return localStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  }
  const ss = getSecureStore();
  if (!ss) return null;
  try {
    return ss.getItem(TOKEN_KEY) ?? null;
  } catch {
    return null;
  }
}

export function setStoredToken(token: string | null): void {
  if (isWeb) {
    try {
      if (token) {
        localStorage.setItem(TOKEN_KEY, token);
      } else {
        localStorage.removeItem(TOKEN_KEY);
      }
    } catch {
      /* noop */
    }
    return;
  }
  const ss = getSecureStore();
  if (!ss) return;
  try {
    if (token) {
      ss.setItem(TOKEN_KEY, token);
    } else {
      ss.deleteItemAsync(TOKEN_KEY).catch(() => {});
    }
  } catch {
    /* noop */
  }
}
